import { render } from "./FooterUmons.vue?vue&type=template&id=9b26bf56&scoped=true"
import script from "./FooterUmons.vue?vue&type=script&lang=js"
export * from "./FooterUmons.vue?vue&type=script&lang=js"

import "./FooterUmons.vue?vue&type=style&index=0&id=9b26bf56&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b26bf56"]])

export default __exports__